import { VtsCorrespondent, type IIdentifier, type Nullable } from "@/models"
import { InstantSchema, type Instant } from "@/Temporal"
import { nullableSchema, objectSchema } from "vue-utils"

export interface VtsLogSummary extends IIdentifier {
	logTime: Instant
	createdAt: Instant
	editedAt: Instant

	from: VtsCorrespondent
	fromOther: Nullable<string>

	to: VtsCorrespondent
	toOther: Nullable<string>

	remarks: string
}

export const VtsLogSummary = objectSchema<VtsLogSummary>({
	id: Number,

	logTime: InstantSchema,
	createdAt: InstantSchema,
	editedAt: InstantSchema,

	from: VtsCorrespondent,
	fromOther: nullableSchema(String),

	to: VtsCorrespondent,
	toOther: nullableSchema(String),

	remarks: String,
})
